export const SET_FACET_INDEX = 'SET_FACET_INDEX'
export const SET_FACET_ATTRIBUTE = 'SET_FACET_ATTRIBUTE'
export const SET_FACET_IS_LOADING = 'SET_FACET_IS_LOADING'
export const SET_FACET_IS_OPEN = 'SET_FACET_IS_OPEN'
export const SET_FACET_AVAILABLE_VALUES = 'SET_FACET_AVAILABLE_VALUES'
export const SET_FACET_SELECTED_VALUE = 'SET_FACET_SELECTED_VALUE'
export const REMOVE_FACET_SELECTED_VALUE = 'REMOVE_FACET_SELECTED_VALUE'
export const REMOVE_ALL_SELECTED_VALUES = 'REMOVE_ALL_SELECTED_VALUES'
export const SET_FACET_ERROR = 'SET_FACET_ERROR'
export const SET_RESET_STATE = 'SET_RESET_STATE'
